import React, { useState, useEffect } from 'react';
import { ContentBox } from "../Content/ContentBox"
import { CancelButton, SearchButton } from './BaseButton';
import { SearchType_Br, SearchType_BrLine, SearchType_Date, SearchType_Input, SearchType_Select, SearchType_AutoSelect, SearchType_MultiSelect } from '../../../item/ItemSearch';
import { SingleInput, SingleSelect } from './BaseInput';
import { AutoSelect } from './AutoSelect';
import { uuid, getKey } from '../../../item/ItemTools';
import { DatePickerInput } from 'rc-datepicker';
import { KEY_ALL } from '../../../item/MyStat/actionList';
import { MultiSelect } from './MultiSelect';

export function BaseSearchBox({ items, action, onChange, }) {
    const [searchItems, setSearchItems] = useState([])
    const [content, setContent] = useState(<></>)
    const [init, setInit] = useState(true)

    useEffect(() => {
        console.log("BaseSearchBox")
        console.log(searchItems)
        if (items !== undefined && items.length > 0 && items !== searchItems) {
            // console.log(items)
            setSearchItems(items)
        }
        // getSearchItem()
    }, [items])

    useEffect(() => {
        if (init && searchItems.length > 0) {
            getContent()
            // setInit(false)
        }
    }, [searchItems])

    function toClear() {
        // console.log("clear")
        var si = []
        searchItems.map(boxItem => {
            if (Array.isArray(boxItem)) {
                boxItem.map(item => {
                    // console.log(item)
                    item.setVal(item.defaultVal)
                    return true
                })
            }
            si.push(boxItem)
            return true
        })
        setSearchItems(si)
        setInit(true)
        if (onChange !== undefined) {
            onChange(KEY_ALL, "")
        }
        return true
    }

    function toSearch() {

        action(searchItems)
    }

    function setFeedback(key, val) {
        // console.log("setFeedback")
        // console.log(key)
        // console.log(val)
        setAction(key, val)
    }

    function setAction(key, val) {
        // console.log(key)
        // console.log(val)
        var si = []
        searchItems.map(boxItem => {
            if (Array.isArray(boxItem)) {
                boxItem.map(item => {
                    // console.log(item)
                    if (item.key === key) {
                        item.setVal(val)
                        return true
                    }
                    return true
                })
            }
            si.push(boxItem)
            return true
        })
        // console.log(searchItems)
        setSearchItems(si)
        if (onChange !== undefined) {
            onChange(key, val)
        }
        return true
    }

    function getSearchItem() {
        var item = <>
            {
                searchItems.map((boxItem) => {
                    if (Array.isArray(boxItem)) {
                        return geteBoxItem(boxItem)
                    } else {
                        return <div className="hr-line-dashed"></div>
                    }
                })
            }
        </>
        // console.log(item)
        return item
    }

    function geteBoxItem(boxItem) {
        var box = <div className="row" key={getKey({})}>
            {
                boxItem.map(item => {
                    if (item.type === SearchType_Input) {
                        // console.log(item)
                        // return <SingleInput title={"以工作地址搜尋"} size={4} />
                        return <SingleInput title={item.title} key={getKey({})} id={item.key} val={item.val} action={setAction} size={item.col} />
                    } else if (item.type === SearchType_Select) {
                        // console.log(item)
                        return <SingleSelect title={item.title}
                            key={getKey({})}
                            id={item.key}
                            val={item.val}
                            valType={item.valType}
                            defaultVal={item.defaultVal}
                            attr={item.attr}
                            action={setAction}
                            size={item.col}
                            v={item.v}
                            n={item.n}
                            hasBlank={item.hasBlank}
                            blankVal={item.blankVal}
                            blankOption={item.blankOption}
                        />
                    } else if (item.type === SearchType_Date) {
                        return <div className={"col-md-" + item.col}
                            key={getKey({})}
                        >
                            <p>{item.title}</p>
                            <DatePickerInput
                                displayFormat='YYYY/MM/DD'
                                returnFormat='YYYY-MM-DD'
                                onChange={
                                    (jsDate, dateString) => {
                                        if (dateString === "Invalid date") {
                                            if (setAction !== undefined) {
                                                setAction(item.key, '')
                                            }
                                        } else {
                                            if (setAction !== undefined) {
                                                setAction(item.key, dateString)
                                            }
                                        }
                                    }
                                }
                                value={item.val}
                                className='my-react-component'
                                showOnInputClick={true}
                            />
                        </div>
                    } else if (item.type === SearchType_BrLine) {
                        return <div className="col-sm-12" key={getKey({})}>
                            <div className="hr-line-dashed"></div>
                        </div>
                    } else if (item.type === SearchType_Br) {
                        return <div className="col-sm-12" key={getKey({})}>
                            <div className=""></div>
                        </div>
                    } else if (item.type === SearchType_AutoSelect) {
                        // console.log("AutoSelect")
                        // console.log(item)
                        return <AutoSelect
                            key={item.key}
                            id={item.key}
                            title={item.title}
                            attr={item.attr}
                            val={item.val}
                            v={item.v}
                            n={item.n}
                            kvFeedback={setFeedback}
                            size={item.col}
                            placeholder={item.blankOption}
                        />
                    } else if (item.type === SearchType_MultiSelect) {
                        // console.log("MultiSelect")
                        // console.log(item)
                        return <MultiSelect
                            key={item.key}
                            id={item.key}
                            title={item.title}
                            attr={item.attr}
                            val={item.val}
                            v={item.v}
                            n={item.n}
                            kvFeedback={setFeedback}
                            size={item.col}
                            placeholder={item.blankOption}
                        />
                    }
                    return <></>
                })
            }
        </div>
        return box
    }

    function getContent() {
        var content = <>
            {
                getSearchItem()
            }
            <div className="row m-t-sm m-t-sm">
                <div className="col-sm-4 col-sm-offset-5">
                    <CancelButton name={"清除"} action={toClear} />
                    <SearchButton action={toSearch} />
                </div>
            </div>
        </>
        setContent(content)
    }

    return (
        <ContentBox hasTitle={false} content={content} hasDrawer={false} />
    )
}